import { mapDTO } from '@twistezo/ts-dto-mapper'
import { isNil } from 'lodash'

import { JSON_SPACE } from 'constants/json'
import { AdUnitDTO } from 'features/inventory/api/types/adUnitDTO'
import { AdUnit } from 'features/inventory/types/adUnit'
import { millisecondsToMinutes } from 'utils/number'
import { DomainRichPlacementMultiAnchor } from '../../types/domainRichPlacementMultiAnchor'
import { DomainRichPlacementMultiAnchorConfigurationDTO } from '../types/domainRichPlacementMultianchorConfigurationDTO'

type From = DomainRichPlacementMultiAnchorConfigurationDTO
type To = DomainRichPlacementMultiAnchor

export const domainRichPlacementMultiAnchorFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const {
      adUnits,
      autoGenerateDivIdsEnabled,
      counterStyle,
      customizeApperanceEnabled,
      customizeBasicSettingsEnabled,
      customStyling,
      customVariableName,
      customVariableTriggerEnabled,
      customVariableValue,
      displayAfterUserInteractionEnabled,
      enabled,
      frequencyCappingEnabled,
      fullWidthModeEnabled,
      impressionLimit,
      matchType,
      path,
      pathTriggerEnabled,
      showCloseButtonEnabled,
      singleAdViewTime,
      timeWindow,
    } = data

    return {
      adUnitIds: adUnits.map((adUnit: Pick<AdUnitDTO, 'id'>): AdUnit['id'] => adUnit.id),
      autoGenerateDivIdsEnabled,
      counterStyle,
      customizeAppearance: customizeApperanceEnabled,
      customizeBasicSettings: customizeBasicSettingsEnabled,
      customStyling: JSON.stringify(customStyling, null, JSON_SPACE),
      customVariableName: customVariableName ?? undefined,
      customVariableTriggerEnabled,
      customVariableValue: customVariableValue ?? undefined,
      displayAfterUserInteraction: displayAfterUserInteractionEnabled,
      enabled,
      frequencyCappingEnabled: frequencyCappingEnabled ?? undefined,
      fullWidthMode: fullWidthModeEnabled,
      impressionLimit: impressionLimit ?? undefined,
      matchType: matchType ?? undefined,
      path: path ?? undefined,
      pathTriggerEnabled,
      showCloseButton: showCloseButtonEnabled,
      singleAdViewTime,
      timeWindow: isNil(timeWindow) ? undefined : millisecondsToMinutes(timeWindow),
    }
  })
